// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".content-error__label {\n  text-align: center;\n  padding-bottom: 3rem;\n}\n", "",{"version":3,"sources":["/home/jenkins/agent/workspace/helpcenter-release/client/src/components/error-views/error-views.less","error-views.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oBAAA;ACCF","file":"error-views.less","sourcesContent":[".content-error__label {\n  text-align: center;\n  padding-bottom: 3rem;\n}\n",".content-error__label {\n  text-align: center;\n  padding-bottom: 3rem;\n}\n"]}]);
// Exports
module.exports = exports;
